import Link from 'next/link';

import { MenuTreeItem } from '@api/pages/types/menus';

import styles from './LinksBlock.module.scss';

const LinksBlock = ({ menu }: { menu?: MenuTreeItem[] | null }) => {
    return (
        <>
            {menu?.map(item => (
                <div className={styles.linksBlock} key={item.name}>
                    <div itemScope itemType="http://schema.org/SiteNavigationElement">
                        <meta itemProp="name" content="Навигационное меню" />
                        <h3 className={styles.linksBlock_title}>{item.name}</h3>

                        <ul className={styles.linksBlock_list}>
                            {item.children.map(({ name, url }) => (
                                <li key={name} className={styles.linksBlock_item}>
                                    <Link
                                        itemProp="url"
                                        href={url}
                                        prefetch={false}
                                        className={styles.linksBlock_link}
                                        aria-label={name}
                                    >
                                        <span itemProp="name">{name}</span>
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            ))}
        </>
    );
};

export default LinksBlock;
